import { useCallback, useEffect, useState } from "react";
import { useToast } from "../components/base_components/ToastContext.tsx";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../redux/hook.ts";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import SessionService from "../api_handlers/services/SessionService.ts";
import { setTeam } from "../redux/teamSlice.ts";
import CardHeader from "../components/common_components/CardHeader.tsx";
import VotingService from "../api_handlers/services/VotingService.ts";
import CardContainer from "../components/common_components/CardContainer.tsx";

const LandingPage = () => {
    const [votingStarted, setVotingStarted] = useState(false);
    const [team, setCurrentTeam] = useState({ id: -1, teamName: '', backgroundImage: '' });
    const { showToast } = useToast();
    const navigate = useNavigate();
    const session = useAppSelector((state) => state.session.session);
    const dispatch = useAppDispatch();
    var sessionId = session?.sessionId;

    const isVotingStarted = useCallback(() => {
        VotingService.isVotingStarted(sessionId)
          .then((res) => {
            console.log(res);
            if (res.data === true) {
              setVotingStarted(true);
            }
          })
          .catch((err) => {
            console.log("🚀 ~ VotingService.isVotingStarted ~ err:", err);
          });
      }, [sessionId]); // Add sessionId as a dependency

    useEffect(() => {
        var teamId = session?.teamId;
        var sessionId = session?.sessionId;
        const getTeam = async () => {
            try {
                var data = await SessionService.getTeam(sessionId, teamId);
                var team = data.data;
                var teamObj = { id: team.id, teamName: team.teamName, backgroundImage: team.backgroundImage, categoryId: team.categoryId };
                dispatch(setTeam(teamObj));
                setCurrentTeam(teamObj);
            }
            catch (err) {
                showToast(err.response.data, "error");
            }
        }
        getTeam();
        isVotingStarted();
        const intervalId = setInterval(isVotingStarted, 5000);
        return () => clearInterval(intervalId);
    }, [ isVotingStarted, session?.teamId, session?.sessionId, showToast, dispatch ]);

    const startVoting = () => {
        navigate("/voting");
    }

    return (
        <CardContainer backgroundImageUrl={`/img/team-background/warriorbg.png`}>
            <Card sx={{
                width: { xs: '98%', sm: '95%', md: '50rem', lg: '56rem' },
                maxWidth: { xs: '98vw', sm: '95vw' },
                padding: 0,
                background: 'url(/img/book-bg.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backdropFilter: 'blur(0.3rem)',
                borderRadius: { xs: '0.75rem', sm: '1rem', md: '1.25rem' },
                border: '0.25rem solid rgba(139, 69, 19, 0.8)',
                boxShadow: '0 1.5rem 4rem rgba(0, 0, 0, 0.9), 0 0 3rem rgba(139, 69, 19, 0.5), inset 0 0.25rem 0.5rem rgba(255, 255, 255, 0.15)',
                zIndex: 1,
                position: 'relative',
                overflow: 'hidden',
                boxSizing: 'border-box',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(135deg, rgba(101, 67, 33, 0.25) 0%, rgba(139, 69, 19, 0.2) 100%)',
                    pointerEvents: 'none',
                    zIndex: 0,
                }
            }} variant="outlined">
                <CardContent sx={{ padding: 0, '&:last-child': { paddingBottom: 0 }, width: '100%', boxSizing: 'border-box', position: 'relative', zIndex: 1 }}>
                    <Box sx={{ width: '100%', boxSizing: 'border-box', position: 'relative', zIndex: 1 }}>
                        <CardHeader teamName={team.teamName}></CardHeader>

                        <Box p={{ xs: 2, md: 3 }} display="flex" justifyContent="center" flexDirection="column" alignItems="center">
                            <Card variant='outlined'
                                key="id1"
                                sx={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.2) 0%, rgba(101, 67, 33, 0.15) 100%)',
                                    backdropFilter: 'blur(5px)',
                                    border: '0.2rem solid rgba(218, 165, 32, 0.6)',
                                    borderRadius: '1rem',
                                    boxShadow: '0 0.5rem 1.5rem rgba(0, 0, 0, 0.5), inset 0 0.125rem 0 rgba(255, 255, 255, 0.1)',
                                }}>
                                <CardContent sx={{
                                    padding: { xs: '2rem 1.5rem', md: '3rem 2rem' },
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 2,
                                }}>
                                    {!votingStarted ? (
                                        <Typography variant="h6" sx={{
                                            fontFamily: "'Philosopher', sans-serif",
                                            color: '#FFD700',
                                            textAlign: 'center',
                                            fontWeight: 700,
                                            fontSize: { xs: '1.3rem', md: '1.5rem' },
                                            textShadow: '0.15rem 0.15rem 0.3rem rgba(0,0,0,0.9), 0 0 0.8rem rgba(255, 215, 0, 0.6)',
                                            lineHeight: 1.5,
                                            padding: { xs: '1.5rem', md: '2rem' },
                                            background: 'linear-gradient(135deg, rgba(218, 165, 32, 0.3) 0%, rgba(184, 134, 11, 0.2) 100%)',
                                            borderRadius: '1rem',
                                            border: '0.2rem solid rgba(255, 215, 0, 0.5)',
                                            boxShadow: '0 0 1.5rem rgba(218, 165, 32, 0.4)',
                                        }}>
                                            ⏳ Please wait for the facilitator to start the session
                                        </Typography>
                                    ) : <></>}
                                    <Button
                                        disabled={!votingStarted}
                                        variant='contained'
                                        onClick={startVoting}
                                        sx={{
                                            padding: { xs: '1rem 2.5rem', md: '1.125rem 3rem' },
                                            fontSize: { xs: '1.1rem', md: '1.25rem' },
                                            fontFamily: "'Cinzel', serif",
                                            fontWeight: 700,
                                            background: votingStarted ? 'linear-gradient(135deg, #DAA520 0%, #B8860B 100%)' : 'rgba(128, 128, 128, 0.5)',
                                            border: '0.15rem solid rgba(255, 215, 0, 0.6)',
                                            borderRadius: '0.75rem',
                                            boxShadow: votingStarted ? '0 0.25rem 1rem rgba(218, 165, 32, 0.4), inset 0 0.0625rem 0 rgba(255, 255, 255, 0.3)' : 'none',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.08rem',
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                background: votingStarted ? 'linear-gradient(135deg, #FFD700 0%, #DAA520 100%)' : 'rgba(128, 128, 128, 0.5)',
                                                boxShadow: votingStarted ? '0 0.5rem 1.5rem rgba(218, 165, 32, 0.6), inset 0 0.0625rem 0 rgba(255, 255, 255, 0.4)' : 'none',
                                                transform: votingStarted ? 'translateY(-0.125rem)' : 'none',
                                            },
                                            '&:active': {
                                                transform: 'translateY(0)',
                                            },
                                            '&:disabled': {
                                                background: 'rgba(128, 128, 128, 0.3)',
                                                color: 'rgba(255, 255, 255, 0.4)',
                                                border: '0.15rem solid rgba(128, 128, 128, 0.3)',
                                            }
                                        }}>
                                        Start Voting
                                    </Button>
                                </CardContent>
                            </Card>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </CardContainer>
    )
}

export default LandingPage